export default __webpack_public_path__ + "static/media/popupError.99e4fd0a.svg";